<template>
    <div class="Details">
    <section>
        <div class="x">
            <div class="box">
              <b-tabs type="is-boxed" v-model="tabItem" >
                    <b-tab-item key="project" value="project">
                        <template #header>
                            <h4 class="title is-5">
                                <i class="fa fa-cubes"></i> General</h4>
                        </template>

                        <div class="columns">
                            <div class="column is-half">
                                <div class="block">
                                    <b-field label="Name">
                                        <b-input v-model="project.name" :disabled="project.userId != currentUser.id"></b-input>
                                    </b-field>
                                    
                                    <b-field label="Description">
                                        <b-input v-model="project.description" :disabled="project.userId != currentUser.id"></b-input>
                                    </b-field>
                                    
                                    <b-field label="Customization Task">
                                        <b-input disabled v-model="project.type"></b-input>
                                    </b-field>

                                    <b-field label="Language">
                                        <b-input disabled v-model="project.language"></b-input>
                                    </b-field>

                                    <b-field label="Foundation Model" message="">
                                        <b-input disabled :value="project.size"></b-input>
                                    </b-field>
                                    
                                    <b-field label="Owner">
                                        <b-input disabled :value="(project.userId == currentUser.id)?currentUser.email:'@'+project.userId"></b-input>
                                    </b-field>
                                    
                                    <b-field label="Workspace">
                                        <b-input disabled :value="(project.userId == currentUser.id)?currentUser.organization:'Private'"></b-input>
                                    </b-field>
                                    

                                    <b-field label="Pipeline Status">
                                        <i class="fa fa-check"></i>&nbsp;&nbsp;Healthy
                                    </b-field>

                                    <!-- <b-field label="Created At">
                                        <b-input disabled v-model="project.createdAt"></b-input>
                                    </b-field> -->
                                </div>
                            </div>
                            <div class="column is-half">
                                <div class="block">
                                    <b-field label="Notifications">
                                        <b-checkbox v-model="project.notifications" :disabled="project.userId != currentUser.id">
                                            Allow e-mail notifications about model's report, calibration, API usage and other project's events.
                                        </b-checkbox>
                                    </b-field>
                                    
                                    <b-field label="Visibility control">
                                        <b-checkbox v-model="project.public" :disabled="project.userId != currentUser.id || isFreePlan()">
                                            Allow public access to this project's APIs
                                        </b-checkbox>
                                    </b-field>

                                </div>
                                
                            </div>
                        </div>
                          <br>
                        

                            <div class="block is-pulled-right" v-if="project.userId == currentUser.id">
                              <div class="buttons">
                              
                                  <b-button  type="is-lightx" @click="update" class="success">Update</b-button>
                              
                                  <b-button type="is-danger" @click="isCardModalActive = true">Delete project</b-button>
                              </div>
                          </div>
                    </b-tab-item>
                    <b-tab-item key="logs" value="logs">
                        <template #header>
                            <h4 class="title is-5"><i class="fa fa-history"></i> Logs</h4>
                        </template>
                        <Logging :id="project.id" :rel="project.id" :projectId="project.id"/>
                    </b-tab-item>
              </b-tabs>
                
            </div>
            
        </div>


        <b-modal v-model="isCardModalActive" :width="640" scroll="keep">
            <div class="card">
                <div class="card-content">
                    <div class="media">
                        <div class="media-content">
                            <p class="title is-4">Are you sure?</p>
                            <p class="subtitle is-5">
                                You are about to delete permanently the entire project with all data, trained models and APIs.
                                <br>
                                Delete operations doesn't rollback the credits used on this project.
                            
                            </p>
                            
                        </div>
                    </div>

                    <div class="content">
                        <p class="subtitle is-5">type <b>delete</b> to confirm</p>
                        <b-input v-model="deleteConfirm" placeholder="Type the delete to confirm" size="is-large"/>
                        <br>
                        <b-button @click="isCardModalActive = false">Cancel</b-button>&nbsp;
                        <b-button @click="deletion" type="is-danger">Delete project</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false">
        </b-loading>
    </section>

    </div>
    
</template>
<script>
import ModalDataset from '@/components/DatasetIncrease.vue'
import ModalModel from '@/components/ModelCreateNew.vue'
import Logging from '@/components/Logging.vue'
import mixin from '@/utils/sharedFunctions.js'

export default {
     mixins: [mixin],
     props: {
        project: {
            type: [Array, Object]
        },
        dataset: Object,
        currentUser: Object,
        tabId: {
            type: [Boolean, String],
            default() {
                return 'project'
            }
        }
     },
     name: "Uploads",
     data: function() {
    return {
        tabItem: this.tabId,
        viewOptions: ['all', 'labeled', 'unlabeled', 'issues'],
        versions: false,
        checkboxCustom: [],
        selected: {text: false, label: 'unlabeled'},
        newLabel: false,
        selectedVersion: 'v1',
        animated: true,
        candidateLabels: [],
        isModalDatasetIncreaseOpen: false,
        isModalModelCreateOpen: false,
        labelKeys: [],
        options: {
        
        },
        total: 0,
        isCardModalActive: false,
        deleteConfirm: null,
        isLoading: false
    }},
    components: {
      ModalDataset,
      ModalModel,
      Logging
    },
    computed: {
      
     },
     methods: {
      update(){
            const toUpdate = {
                projectId: this.project.id,
                update: {
                    name: this.project.name,
                    description: this.project.description || '',
                    notifications: this.project.notifications || false,
                    public: this.project.public || false
                }
            }
            this.$store.dispatch("updateProject", 
                toUpdate
            );

            this.$buefy.snackbar.open({
                message: 'Project updated',
                type: "is-white",
                position: 'is-bottom-left',
                queue: false,
                actionText: "",
            })
      },
      deletion(){

          if (this.deleteConfirm == "delete") {
            this.isLoading = true

            const toDelete = {
              projectId: this.project.id,
              datasetId: this.project.datasetId,
              models: this.project.models
            }
              
            this.$buefy.snackbar.open({
                message: 'Deleting project...',
                type: "is-white",
                position: 'is-bottom-left',
                queue: false,
                actionText: "",
            })
            

            this.$store.dispatch("deleteProject", 
              toDelete
            );
            
            setTimeout(() => 
              this.$router.push("/dashboard"), 
              1 * 1000)

          }

        }
     },
     created() {
        
        
     }
   };
</script>

<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>